import React, { FC } from "react";
import { MatterRelationEditor } from "../matter-relation-editor";
import { WorkspaceList } from "../workspace-list";
import { Assumption } from "../../../data-types";

export type MatterAssumptionsEditorProps = {
  loading: boolean;
  assumptions: Assumption[];
  onAddNew: () => void;
  onSave: (assumption: Assumption, text: string) => Promise<void>;
  onDelete: (assumption: Partial<Assumption>) => Promise<void>;
  onReorder: (activeId: number, overId: number) => void;
  renderLibraryActions?: (assumption: Assumption) => React.ReactNode;
};

export const MatterAssumptionsEditor: FC<MatterAssumptionsEditorProps> = ({
  loading,
  assumptions,
  onAddNew,
  onSave,
  onDelete,
  onReorder,
  renderLibraryActions,
}) => {
  return (
    <MatterRelationEditor
      workspaceContent={
        <WorkspaceList
          workspaceItemType="assumption"
          itemKeyProperty="id"
          itemTextProperty="text"
          loading={loading}
          items={assumptions}
          deleteItem={(item) => onDelete(item)}
          saveItem={(item, text) => onSave(item, text)}
          onReorder={onReorder}
          renderExtraActions={renderLibraryActions}
        />
      }
      addNew={onAddNew}
      showAddNew={true}
    />
  );
};
